import queryString from 'query-string';
import callApi, { CallApiResult } from 'src/api';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';

export const getAddressConfirmations = (pageable: PageableQueryParams = {}): Promise<CallApiResult> => {
    let query = queryString.stringify({ ...pageable }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;
    const endpoint = `/api/admin/addresses/open${query}`;
    return callApi(endpoint);
};
